export function getSafeRedirectPath(value: string | null | undefined): string {
    if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) {
        return '/dashboard';
    }
    return value;
}

export function withRedirect(path: string, redirectPath: string): string {
    const params = new URLSearchParams({ redirect: getSafeRedirectPath(redirectPath) });
    return `${path}?${params.toString()}`;
}
